export default {
  api: 'https://api.eyeson.team',
  allowSafariSFU: true,
  screencapture: true
};
